module.exports = __webpack_public_path__ + "img/19-l.cd52cbe7.png";